window.setCookie = function(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

window.getCookie = function(name) {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    var parts = cookie.split('=');
    if (parts[0] === name) {
      return parts[1];
    }
  }
  return null;
};

window.deleteCookie = function(name) {
  setCookie(name, "", new Date(0));
};

$(document).ready(function(){ 

   $('a[href="/pages/reseller"]').parent().parent().css({ "min-width": "230px" }) 
  
  var $retailerType = $('#retailerType'), $locationType = $('#locationType'), $options = $locationType.find('option');
    
  $retailerType.on('change', function() {
  	$locationType.html($options.filter('[data-state="'+this.value+'"]')); 
  }).trigger('change');

  $('[name="account_logout_url"]:first').bind('click',function(e){
      e.preventDefault();
      console.log('-----CLEAR CART-----');   
    
      var cartUpdatePromises = [];

      $.ajax({
        url: `${window.Shopify.routes.root}cart/clear.js`,
        method: "GET",
        dataType: "json",
        success: function(data) {
          window.location.href = $('[name="account_logout_url"]:first').prop('href');
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error:", errorThrown);
        }
      });

  });

  $('[name="account_login_url"]:first').bind('click',function(e){
      e.preventDefault();
      console.log('-----CLEAR CART-----');   
    
      $.ajax({
        url: `${window.Shopify.routes.root}cart/clear.js`,
        method: "GET",
        dataType: "json",
        success: function(data) {
          window.location.href = $('[name="account_login_url"]:first').prop('href');
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error:", errorThrown);
        }
      });

  });
  
 $(".quotes-list-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 300,
      infinite: true,
      autoplaySpeed: 5000,
      autoplay: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
  }); 

  $('.readmore').on('click', function(event) {
    event.preventDefault();
    var descriptionFull = $('.product-description-full');
    descriptionFull.css('display', 'block');
    var descriptionShort = $('.product-description-short');
    descriptionShort.css('display', 'none');
  });
  
  $('.readless').on('click', function(event) {
    event.preventDefault();
    var descriptionFull = $('.product-description-full');
    descriptionFull.css('display', 'none');
    var descriptionShort = $('.product-description-short');
    descriptionShort.css('display', 'block');
  });


  $(".image-with-text-tooltip-list__item .tooltip-icon").off("click").on("click", function(){
    if($(this).hasClass("opened")){
        $(this).removeClass("opened");
        $(this).find('span').text("+");
        $(this).closest(".image-with-text-tooltip-list__item").find(".tooltip").removeClass("is-active");
    }
    else{
        $(".image-with-text-tooltip-list__item .tooltip-icon").removeClass("opened");
        $(".image-with-text-tooltip-list__item .tooltip-icon span").text("+")
        $(".image-with-text-tooltip-list__item .tooltip").removeClass("is-active");
        $(this).find('span').text("-");
        $(this).addClass("opened");
        $(this).closest(".image-with-text-tooltip-list__item").find(".tooltip").addClass("is-active");
      }
  });

  $('.multirow__tab-list .multirow__tab-list-item').on('click', 'a', function(event) {
      if($(this).has('active')){
        $('.multirow__tab-list .multirow__tab-list-item a').removeClass('active');
        $(this).addClass('active');
      }
      var $tab_section = $($(this).attr('href'));
      var Tab_section_Top = $tab_section.offset().top - 180;  
      $('html, body').animate({scrollTop: Tab_section_Top } );
      event.preventDefault();
  });

  $('.multirow__tab-list-item a[href^="#"]').on("click", function(event) {
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top - 50
    }, 800, function(){
      window.location.hash = hash;
    });
  });

  // Set up the observer
  //FIX 08052025
onRechargeWidgetReady(() => {
  console.log("Recharge widget has been rendered.");
  // Place your post-initialization logic here

  const swatch__active = document.querySelector('.swatch--active');
  if(!swatch__active){
    //startCheckDiv();
    const $target = $('div[id*="RechargeWidget_"]');
    const target = $target[0];
    //$target.show();
    if (target) {
      const fullId = target.id;
      const idSuffix = fullId.split('RechargeWidget_')[1];
      console.log("*********Recharge Widget ID Suffix:", idSuffix);

      if(window.Recharge.widgets[idSuffix].state.variant == 0){
        //$target.empty();
        $target.hide();
        
        //target.appendChild(document.createComment(''));
      }
      else{
        //$target.show();
      }
    }
  }
  
});
});

var padding_apply = false;
var nav_init_pos = 0;

function set_nav_pos() {
   nav_init_pos = $('slideshow-component').innerHeight() + $('header').innerHeight() - ($('.multirow__tab-wrapper').innerHeight() / 2);
}

$(document).ready(function(){
  
   set_nav_pos();
   $(window).on('resize', function() {
     set_nav_pos(); 
     $(window).trigger('scroll');
   });
  
   $(window).on('scroll', function() {
         if ($(window).scrollTop() >= nav_init_pos) {
            if(!padding_apply) {
              $('.multirow__tab-wrapper').addClass('fixed');
              $('.multirow__tab-wrapper').css('top', $('header').innerHeight());
              padding_apply = true;
            }
         }
         else {
            if(padding_apply) {
              $('.multirow__tab-wrapper').removeClass('fixed');
              padding_apply = false;
            }
         }
    });
});

window.addClassToCartDrawer = function(){
  if(document.querySelectorAll('cart-drawer-items').length > 0){
    if(!document.querySelector('cart-drawer-items').classList.contains("footer-up")){
      document.querySelector('cart-drawer-items').classList.add("footer-up");
    }  
  }
}

if(document.querySelectorAll(".header__inline-menu").length > 0){
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => { item.removeAttribute("open"); });
      item.addEventListener("mouseleave", () => { item.removeAttribute("open"); });
    });
  });
}


if(document.querySelectorAll(".header__icons header-menu").length > 0 ) {  
  let accountDropdown = document.querySelector(".header__icons header-menu").querySelectorAll("details");
  accountDropdown.forEach(accountDropdown => {
    accountDropdown.addEventListener("mouseover", () => {
      accountDropdown.setAttribute("open", true);
      accountDropdown.addEventListener("mouseleave", () => { accountDropdown.removeAttribute("open"); });
    });
  });
}

function onRechargeWidgetReady(callback) {
  const $target = $('div[id*="RechargeWidget_"]');
  const target = $target[0];
  if (!target) {
    console.warn('Recharge widget container not found.');
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    if (target.innerHTML.trim() !== '') {
      //obs.disconnect(); // Stop observing
      callback(); // Execute your function
    }
  });

  observer.observe(target, { childList: true });
}



function startCheckDiv()
  {

const checkDiv = setInterval(() => {
  if(document.querySelectorAll(".rc-radio__price").length > 0 ) {

    console.log('-------startCheckDiv------------');
    
    const newElement = document.createElement('label');
    const parentElement = document.querySelector(".rc-widget div.rc-template__radio") // Select the parent element
    clearInterval(checkDiv);
    // Recharge Subscriptions
    const price = document.querySelector(".product-price-rc-widget-custom").innerHTML;
    const cleanPrice = price.match(/\d+(\.\d{1,2})?/)[0];
    var Percentage = document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML.trim().split("##separator##")[2];
    window.discValueOff = parseInt(document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML.trim().replace("$",""));
    var span_1 = document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML.trim().split("##separator##")[0]
    var span_2 = document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML.trim().split("##separator##")[1];
    var span_3 = `<s>${document.querySelector(".product-price-rc-widget-custom").innerText}</s> ${document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML.trim()}`;
    // var span_4 = document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML.trim().split("##separator##")[2];
    var percentageValue = parseInt(document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML.trim().split("##separator##")[2].replace("%",""));
    // var discountPriceValue = (cleanPrice - (cleanPrice - (cleanPrice * (percentageValue / 100)))).toFixed(2);
    var discountPriceValue = cleanPrice - parseInt(document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML.trim().replace("$",""));
    window.percentageValue = percentageValue;
    window.discountValue = discountPriceValue;
    var span_4 = discountPriceValue;
    document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[0].innerHTML = `<span> ${span_1} </span> <span> ${span_2} </span>`;
    document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML = `<span> ${span_3} </span> <span class="save--content-custom"> SAVE $${span_4} each month </span>`;
    (document.querySelectorAll("[vipsubscription] .price__container .price-item.price-item--regular").length > 0) ? document.querySelector("[vipsubscription] .price__container .price-item.price-item--regular").innerHTML = span_3 : "";
    
    // Recharge Onetime
    var span_1 = span_2 = span_3 = span_4 = "";
    document.querySelectorAll(".rc-widget .onetime-radio .rc-radio__label")[0].innerHTML.trim().split("##separator##");
    var span_1 = document.querySelectorAll(".rc-widget .onetime-radio .rc-radio__label")[0].innerHTML.trim().split("##separator##")[0]
    // var span_2 = document.querySelectorAll(".rc-widget .onetime-radio .rc-radio__label")[0].innerHTML.trim().split("##separator##")[1]
    // var span_3 = document.querySelectorAll(".rc-widget .onetime-radio .rc-radio__label")[0].innerHTML.trim().split("##separator##")[2]
    var span_3 = document.querySelector(".product-price-rc-widget-custom-ot").innerText.trim();
    
    var finalString = `<span> ${span_1} </span> <span> ${span_2} </span> <span class="rc--price-custom"> ${span_3} </span>`;
    document.querySelectorAll(".rc-widget .onetime-radio .rc-radio__label")[0].innerHTML = finalString;

    const swatch__active = document.querySelector('.swatch--active');
    if(swatch__active){
      const data_swatch_option = swatch__active.getAttribute('data-swatch-option');
      console.log('data_swatch_option: ' + data_swatch_option); // Output: "Standard Protocol"
      if(data_swatch_option.includes('Protocol')){
          const priceSpan1  = document.querySelector('span.rc-radio__price');
          if (priceSpan1) {
            priceSpan1.style.display = 'none';
          }
        const priceSpan2  = document.querySelector('span.rc--price-custom');
          if (priceSpan2) {
            priceSpan2.style.display = 'none';
          }
      }
    }
    
    document.querySelectorAll(".rc-widget input[name='purchaseOption']").forEach(ele=> {
      ele.addEventListener("change", function(e){
        
        let closestForm = document.querySelector(".shopify-product-form");
        let closestSellingPlan = closestForm.querySelector('[name="selling_plan"]');
        let closestVariantId = closestForm.querySelector('[name="id"]');

        //document.querySelector(".product-form__input quantity-input input").value=1;
        //setTimeout(function(){
        //    var event = new Event('change');
        //    document.querySelector(".product-form__input quantity-input input").dispatchEvent(event);
        //},100);
        
        if(e.target.value == "subscription"){
          closestSellingPlan.value = (typeof window.location.search.split("selling_plan=")[1] !== "undefined" ? window.location.search.split("selling_plan=")[1] : window.productJson.selling_plan_groups[0].selling_plans[0].id);
          closestVariantId.value = window.productJson.variants[0].id;
        }
        if(e.target.value == "onetime"){
          closestSellingPlan.value = "";
          closestVariantId.value = window.productJson.variants[0].id;
        }
        e.target.closest(".rc-template__radio").querySelectorAll("label").forEach(labelEl => {
          labelEl.classList.remove("rc-radio--active");
        })
        e.target.closest("label").classList.add("rc-radio--active");
        
        window.updateRCWidgetPrice(1, true);
        
      }, true);
    })

    /* For Buy 2 get 1 free option in recharge - Start */
    
    // if (parentElement) {
    //   newElement.for = 'custom-radio-subscription';
    //   newElement.classList.add('custom-radio','px-3','py-2','rc-radio');
    //   newElement.id = "subscription-label-custom";
      
    //   newElement.innerHTML = `
    //     <input id="custom-radio-subscription" class="rc-radio__input m-0 mr-3" type="radio" name="purchaseOption" value="threemonthproduct"/>
    //     <span class="rc-radio__label">
    //       <span class="rc-radio__subscription">
    //         <span>Buy 2 Get 1 FREE Subscription</span> 
    //         <span>(Cancel after 3 months)</span>
    //       </span>
    //       <span class="rc-radio__price">
    //         <span><s>$${(cleanPrice * 3).toFixed(2)}</s> $${(cleanPrice * 2).toFixed(2)}</span>
    //         <span>SAVE $${cleanPrice} </span>
    //       </span>
    //     </span>
    //   `;
    //   newElement.querySelector("input").addEventListener("change", function(e){
    //     let closestForm = e.target.closest("product-info").querySelector("div product-form form");
    //     closestForm.querySelector('[name="selling_plan"]').value = 8177778966;
    //     closestForm.querySelector('[name="id"]').value = 44645108580630;

    //     e.target.closest(".rc-template__radio").querySelectorAll("label").forEach(labelEl => {
    //       labelEl.classList.remove("rc-radio--active");
    //     })
    //     e.target.closest("label").classList.add("rc-radio--active");
    //   });
    // }
    //   const lastElement = parentElement.lastElementChild; // Get the last element
    //   parentElement.insertBefore(newElement, lastElement); // Insert the new element before the last element
    //   newElement.style.display = "flex";
    
    /* For Buy 2 get 1 free option in recharge - End */
  }
  if(document.querySelectorAll(".rc-selling-plans-single").length > 0) {
    clearInterval(checkDiv);
    // document.querySelector(".cta-wrapper").setAttribute("hidden", "hidden");
  }


  
}, 100);

  }

startCheckDiv();

var rc_customer_hash = "";
var rc_customer_token = "";
var subscription_pageUrl = "";

var getConvertedDate = function(dateString){
  // const dateString = "2023-05-27T00:00:00";
  const dateObj = new Date(dateString);
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const month = monthNames[dateObj.getMonth()];
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const formattedDate = `${month} ${day}, ${year}`;
  return(formattedDate);
}

function sortDataByDateDescending(data) {
  return data.sort((a, b) => {
    const dateA = new Date(a.next_charge_scheduled_at);
    const dateB = new Date(b.next_charge_scheduled_at);
    return dateB - dateA;
  });
}

var getSubDetails = function(){
    if(document.querySelectorAll("[subscription-data-my-account]").length > 0){
      $.ajax({
        url: `https://${window.location.host}/tools/recurring/portal/${rc_customer_hash}/request_objects?token=${rc_customer_token}`,
        type: "get",
        dataType: "json",
        data: {
          schema:
            '{ "addresses": { "discount": { "id": "parent.discount_id" } }, "subscriptions": { "product": {} }, "onetimes": { "product": {} }, "customer": {}, "settings": {}, "store": {} }',
        },
      })
      .done(function (response) {

      for(let i = 0 ; i < response.subscriptions.length ; i++){

      const activeData = response.subscriptions.filter(obj => obj.status === "ACTIVE");
      const activeSortedData = sortDataByDateDescending(activeData);
        if(i == 0){
          document.querySelector("[subscription-data-my-account] .subscription .subscription-current-product").innerHTML = `
            ${document.querySelector("[subscription-data-my-account] .subscription .subscription-current-product").innerHTML}
            <div class="sub-prod-detail">
              <span class="sub-product-name">${activeSortedData[i].product_title}</span><br>
              <span>Delivery Frequency: ${activeSortedData[i].order_interval_frequency} ${activeSortedData[i].order_interval_unit}</span><br>
              <span>${getConvertedDate(activeSortedData[i].next_charge_scheduled_at)}</span><br>
            </div>
            <div>
              <a class="button button--primary" href="/tools/recurring/portal/${rc_customer_hash}/subscriptions?token=${rc_customer_token}"> Edit </a>
            </div>
          `;

          if(activeSortedData.length == 1){
            document.querySelector("[subscription-data-my-account] .subscription .subscription-next-product").innerHTML = `
            ${document.querySelector("[subscription-data-my-account] .subscription .subscription-next-product").innerHTML}
            <div class="sub-prod-detail">
              <span class="sub-product-name">${activeSortedData[i].product_title}</span><br>
              <span>Delivery Frequency: ${activeSortedData[i].order_interval_frequency} ${activeSortedData[i].order_interval_unit}</span><br>
              <span>${getConvertedDate(activeSortedData[i].next_charge_scheduled_at)}</span><br>
            </div>
            <div class="button-wrapper">
              <a class="button button--primary recharge-update-button" href="/tools/recurring/portal/${rc_customer_hash}/subscriptions?token=${rc_customer_token}"> Modify My Box? </a>
            </div>
          `;
          }
        }
  
        if(i == 1){
          document.querySelector("[subscription-data-my-account] .subscription .subscription-next-product").innerHTML = `
            ${document.querySelector("[subscription-data-my-account] .subscription .subscription-next-product").innerHTML}
            <div class="sub-prod-detail">
              <span class="sub-product-name">${activeSortedData[i].product_title}</span><br>
              <span>Delivery Frequency: ${activeSortedData[i].order_interval_frequency} ${activeSortedData[i].order_interval_unit}</span><br>
              <span>${getConvertedDate(activeSortedData[i].next_charge_scheduled_at)}</span><br>
            </div>
            <div>
              <a class="button button--primary" href="/tools/recurring/portal/${rc_customer_hash}/subscriptions?token=${rc_customer_token}"> Modify My Box? </a>
            </div>
          `;
        }
      }
        
      if(response.subscriptions.length > 0){
        document.querySelector("[subscription-data-my-account] .subscription").classList.remove("visually-hide-content");
      }
    })
    .fail(function (response) {
      // Request failed
      console.log(response);
    });
  }
}

if(typeof window.shopifyCustomerId !== "undefined"){
   var urlTokenHash = `${window.location.origin}/tools/recurring/get_rc_token/${window.shopifyCustomerId}`;
   $.ajax({
    url: urlTokenHash,
    type: 'GET',
    async : false,
    success: function(data){
      rc_customer = JSON.parse(data.match(/{"rc_customer":.*}}/g)[0]).rc_customer;
      rc_customer_hash = rc_customer.hash;
      rc_customer_token = rc_customer.token;

      if(rc_customer.error == "customer_not_found"){
        if(document.querySelectorAll(".manage-subscriptions-js").length > 0){
          document.querySelector(".manage-subscriptions-js").closest("li").classList.add("visually-hidden");
        }
        if(document.querySelectorAll("[subscription-data-my-account] .non-subscription").length > 0){
          document.querySelector("[subscription-data-my-account] .non-subscription").classList.remove("visually-hide-content");
        }
      }
      else{
        if(document.querySelectorAll(".manage-subscriptions-js").length > 0){
          document.querySelector(".manage-subscriptions-js").href = `/tools/recurring/portal/${rc_customer_hash}/subscriptions?token=${rc_customer_token}`;
        }
        
        if(document.querySelectorAll(".payment-details-url").length > 0){
          document.querySelector(".payment-details-url").href = `/tools/recurring/portal/${rc_customer_hash}/payment_methods?token=${rc_customer_token}`;
        }

        if(document.querySelectorAll(".subscription-current-product-update .go-to-subscription").length > 0){
          document.querySelector(".subscription-current-product-update .go-to-subscription").href = `/tools/recurring/portal/${rc_customer_hash}/subscriptions?token=${rc_customer_token}`;
        }
        
        getSubDetails();
      }

    },
    error: function(error){
      console.log('error', error);
    }
  });
}

if(document.querySelectorAll(".reset_password_link").length > 0){
  document.querySelector(".reset_password_link").addEventListener("click", function(e){
    e.preventDefault();
    sessionStorage.setItem("fromAccountPage", "yes");
    window.open(e.currentTarget.href, '_blank');
  }, true);
}

if(document.querySelectorAll(".recover_url_js").length > 0){
  if(sessionStorage.getItem("fromAccountPage") == 'yes'){
    // document.querySelector(".recover_url_js").href = window.location.origin + "/pages/my-account";
    sessionStorage.setItem("fromAccountPage", "no");
    document.querySelector(".recover_url_js").addEventListener("click", function(){
      window.close();
    }, true)
  }
}

if(window.location.href.includes("tools/recurring/portal/")){
  const checkRCLogoutBtn = setInterval(() => {
    if(document.querySelectorAll('a[data-testid="recharge-internal-logout-button"]').length > 0) {
      const element = document.querySelector('a[data-testid="recharge-internal-logout-button"]');
      const clone = element.cloneNode(true);
      clone.removeAttribute("onclick");
      element.parentNode.replaceChild(clone, element);
      clone.innerHTML = clone.innerHTML.replace(">Logout<", ">Back to Account<");
      clone.href=`${window.location.origin}/pages/my-account`;  
      clearInterval(checkRCLogoutBtn);
    } 
  }, 100);
}

if(window.location.pathname.indexOf('/products/') !== -1) {
  const checkRCRadioBtns = setInterval(() => {
    if(document.querySelectorAll('input[name="purchaseOption"]').length > 0){   
      
      const productTypeRadios = document.querySelectorAll('input[name="purchaseOption"]');

      if(document.querySelector('input[name="purchaseOption"]:checked').value == 'subscription'){
        setTimeout(function(){
          (document.querySelectorAll('variant-radios [value="Subscription"]').length > 0) ? document.querySelector('variant-radios [value="Subscription"]').click() : "";
        },100)
      }
      else if(document.querySelector('input[name="purchaseOption"]:checked').value == 'onetime' ){
        setTimeout(function(){
          (document.querySelectorAll('variant-radios [value="Non Subscription"]').length > 0) ? document.querySelector('variant-radios [value="Non Subscription"]').click() : "";
        },100)
      }
      
      productTypeRadios.forEach(radio => {
        radio.addEventListener('change', (event) => {
          if(event.target.value == 'subscription'){
            setTimeout(function(){
              (document.querySelectorAll('variant-radios [value="Subscription"]').length > 0) ? document.querySelector('variant-radios [value="Subscription"]').click() : "";
            },100)
          }
          else if(event.target.value == 'onetime'){
            setTimeout(function(){
              (document.querySelectorAll('variant-radios [value="Non Subscription"]').length > 0) ? document.querySelector('variant-radios [value="Non Subscription"]').click() : "";
            },100)
          }
          else{
              //console.log("Else Part");
          }
        });
      });
      clearInterval(checkRCRadioBtns);
    }
  },100);
  if(document.querySelectorAll('.WhoseSale-hide-RC').length > 0) {
    const checkRcDiv = setInterval(() => {
      if(document.querySelectorAll('.recharge-subscription-widget input[value="onetime"]').length > 0) {
        document.querySelector('.recharge-subscription-widget').style.display = "none";
        setTimeout(function(){
          document.querySelector('.recharge-subscription-widget input[value="onetime"]').click();
        },100);
        clearInterval(checkRcDiv);
      } 
    }, 100); 
  }
}

document.querySelectorAll(".discount-field").forEach(ele => {
  ele.addEventListener("blur", function(){
    if(ele.value.trim() == ""){
      ele.setAttribute("name","");
    }
  }, true)
});

window.updateRCWidgetPrice = function(qty, updateAll){
  if (window.location.pathname.indexOf('/products/') !== -1) {
    const price = document.querySelector(".product-price-rc-widget-custom").innerHTML;
    const cleanPrice = price.match(/\d+(\.\d{1,2})?/)[0];

    const priceOT = document.querySelector(".product-price-rc-widget-custom-ot").innerHTML;
    const cleanPriceOT = priceOT.match(/\d+(\.\d{1,2})?/)[0];

    if(updateAll){
      document.querySelectorAll(".rc-widget input[name='purchaseOption']").forEach(ele => {
        if(ele.value == "onetime"){
        var multipliedPrice = (qty * cleanPriceOT);
            ele.closest("label").querySelector(".rc--price-custom").innerHTML = `$${multipliedPrice}`;
        }
        else if(ele.value == "subscription"){
          const str = ele.closest("label").innerText;
          // const regex = /SAVE\s+(\d+(\.\d+)?)%/;
          const regex = /SAVE \$([\d.]+)/;
          const match = regex.exec(str);
          if (match) {
            const percentValue = match[1];
            // const discountedPrice = cleanPrice - (cleanPrice * (percentValue / 100));
            const discountedPrice = (cleanPrice - (cleanPrice * (window.percentageValue / 100))).toFixed(2);
            // const discountedPrice = window.discountValue;
            var amountOffValue = (cleanPrice - (cleanPrice - (cleanPrice * (window.percentageValue / 100)))).toFixed(2);
            // document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML = `<span> $${ (discountedPrice * qty).toFixed(2) }  <s>$${(cleanPrice * qty).toFixed(2) }</s> </span> <span class="save--content-custom"> ${document.querySelector(".save--content-custom").innerText} </span>`;
            document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML = `<s>$${(cleanPrice * qty) }</s> <span> $${ (window.discValueOff * qty) } </span> <span class="save--content-custom"> SAVE $${(window.discountValue * qty)} each month </span>`;
          }
        }
      })
    }
    else{
      if(document.querySelector(".rc-widget input:checked") != null){
        if(document.querySelector(".rc-widget input:checked").value == "onetime"){
          var multipliedPrice = (qty * cleanPriceOT);
          document.querySelector(".rc-widget input:checked").closest("label").querySelector(".rc--price-custom").innerHTML = `$${multipliedPrice}`;
        }
        else if(document.querySelector(".rc-widget input:checked").value == "subscription"){
          const str = document.querySelector(".rc-widget input:checked").closest("label").innerText;
          const regex = /SAVE \$([\d.]+)/;
          const match = regex.exec(str);
          if (match) {
            const percentValue = match[1];
            // const discountedPrice = cleanPrice - (cleanPrice * (percentValue / 100));
            const discountedPrice = (cleanPrice - (cleanPrice * (window.percentageValue / 100))).toFixed(2);
            // const discountedPrice = window.discountValue;
            var amountOffValue = (cleanPrice - (cleanPrice - (cleanPrice * (window.percentageValue / 100)))).toFixed(2);
            // document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML = `<s>$${(cleanPrice * qty).toFixed(2) }</s> <span> $${ (discountedPrice * qty).toFixed(2) } </span> <span class="save--content-custom"> ${document.querySelector(".save--content-custom").innerText} </span>`;
            document.querySelectorAll(".rc-widget .subscription-radio .rc-radio__label > span")[1].innerHTML = `<s>$${(cleanPrice * qty)}</s> <span> $${ (window.discValueOff * qty) } </span> <span class="save--content-custom"> SAVE $${(window.discountValue * qty)} each month </span>`;
            (document.querySelectorAll("[vipsubscription] .price__container .price-item.price-item--regular").length > 0) ? document.querySelector("[vipsubscription] .price__container .price-item.price-item--regular").innerHTML = `<s>$${(cleanPrice * qty)}</s> <span> $${ (window.discValueOff * qty) } </span>` : "";
          }
        }
        else{
          // do nothing
        }
      }
    }
  }
}

var $retailerType = $('#retailerType'), $locationType = $('#locationType'), $options = $locationType.find('option');
$retailerType.on('change', function() {
  $locationType.html($options.filter('[data-state="'+this.value+'"]'));
});

const tabLinks = $('.verticle-tab-list li a');

tabLinks.click(function(event) {
  var $this = $(this);
  console.log($this);
  event.preventDefault();
  $this.closest('.verticle-tab-list').find('li a.active').removeClass('active');
  $this.closest('.vericle-tabs-wrapper').find('.tab-content.active').removeClass('active');
  $this.closest('.verticle-tab-list').find('.verticle-tab-list-item.verticle-tab-list-item-active').removeClass('verticle-tab-list-item-active');
  $this.addClass('active');
  $this.parent().addClass('verticle-tab-list-item-active');
  $this.closest('.vericle-tabs-wrapper').find($this.attr('href')).addClass('active');
}); 

window.addEventListener("DOMContentLoaded", (event) => {

  if(document.querySelector("#countdown") != null)
  window.DiscountCode = document.querySelector("#countdown").dataset.discountcode;
  
  if(document.querySelectorAll(".page-locked").length > 0){
    document.querySelector('[name="checkout_url"]').remove();
  }

  if(document.querySelectorAll(".custom-buy-now-btn").length > 0){
    document.querySelector(".custom-buy-now-btn").addEventListener("click", function(e){

      console.log(`/cart/${e.target.getAttribute("data-product-id")}:${e.target.closest("product-info").querySelector("quantity-input input[name='quantity']").value}`);
      
      // window.location.href = `/cart/${e.target.getAttribute("data-product-id")}:${e.target.closest("product-info").querySelector("quantity-input input[name='quantity']").value}`
    })
  }

  window.showHideNotiForAppliedDisc = function(noti) {
    const displayValue = noti ? "block" : "none";
    document.querySelectorAll("#code-applied").forEach(ele => {
      ele.style.display = displayValue;
    });
  };
  
  window.applyDiscountEvent = function(){
    const shopUrl = window.location.origin;
    const discountSubmitBtn = document.querySelectorAll('.apply-discount-code');
    discountSubmitBtn.forEach(el => {
      if(!el.classList.contains("EventAdded")){
        el.classList.add("EventAdded");
        el.addEventListener('click', async (event) => {
          event.preventDefault();
          const discountCodeInput = el.parentNode.querySelector(".discount-field");
          const discountCode = discountCodeInput.value;
          event.target.classList.add('loading');
      
          if (!discountCode) {
            document.querySelectorAll(".discount-field").forEach(elem => {
              elem.value = discountCode;
              elem.setAttribute("name", "discount");
            });
            window.setCookie("DiscountCodeApplied", discountCode);
            window.showHideNotiForAppliedDisc(false);
            el.classList.remove('loading');
          } else {
            try {
              await fetch(`${shopUrl}/cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 'attributes[discount]': discountCode })
              });
              document.querySelectorAll(".discount-field").forEach(elem => {
                elem.value = discountCode;
                elem.setAttribute("name", "discount");
              });
              window.setCookie("DiscountCodeApplied", discountCode);
              window.showHideNotiForAppliedDisc(true);
            } catch (error) {
              console.error(error);
            } finally {
              el.classList.remove('loading');
            }
          }
        });
      }
    });
  }
  
  window.checkandapplyDiscount = function() {
    window.applyDiscountEvent();
    const cookieDiscCode = window.getCookie("DiscountCodeApplied");
    document.querySelectorAll(".discount-field").forEach(elem => {
      elem.value = cookieDiscCode;
      elem.setAttribute("name", "discount");
    });
    if (cookieDiscCode) {
      window.showHideNotiForAppliedDisc(true);
    }
    else{
      window.showHideNotiForAppliedDisc(false);
    }
    if(window.getCookie("form_submitted")){
      document.querySelector(".announcement-bar-default").classList.add("visually-hidden");
      document.querySelector(".after-submit-announcement-bar").classList.remove("visually-hidden");
      document.querySelector(".announcement-bar").classList.add("custom-bar");
    }
  };
  
  window.checkandapplyDiscount();

  //  video icon click play video

  if(document.querySelectorAll(".video-box .icon-box").length > 0){

    var myVideo = document.querySelector(".video-box video");
    var playButton = document.querySelector(".video-box .icon-box");
    
      playButton.addEventListener('click', function() {
        if (document.querySelector('.video-box').classList.contains('video-playing')) {
          myVideo.pause();
          document.querySelector('.video-box').classList.add('video-paused');
          document.querySelector('.video-box').classList.remove('video-playing');
        } else {
          myVideo.play();
          document.querySelector('.video-box').classList.add('video-playing');
          document.querySelector('.video-box').classList.remove('video-paused');
        }
      });
    
  }

  // add "No Thanks" button to the popup newsletter form.
  const checkHubspotForm = setInterval(() => {
    if(document.querySelectorAll(".newsletter-popup .hbspt-form [type='submit']").length > 0) {
      const actionsElement = document.querySelector(".hs_submit .actions");
      const submitBtn = actionsElement.querySelector("[type='submit']");
      submitBtn.addEventListener("click", function(){

        document.querySelector(".newsletter-popup .popup-wrap").classList.add("visually-hidden");
        document.querySelector(".newsletter-popup .popup-thankyou").classList.remove("visually-hidden");
        
        document.querySelector(".announcement-bar-default").classList.add("visually-hidden");
        document.querySelector(".after-submit-announcement-bar").classList.remove("visually-hidden");
        document.querySelector(".announcement-bar").classList.add("custom-bar");
        
        window.setCookie("DiscountCodeApplied", window.DiscountCode);
        window.setCookie("form_submitted", "yes", "7");
        window.checkandapplyDiscount();
        setTimeout(function(){
          document.querySelector(".newsletter-popup .close-btn").click();
        },10000);
      });
      const button = document.createElement("button");
      button.textContent = "No Thanks";
      button.classList.add("newsletter-form__button", "close");
      button.type = "button";
      button.addEventListener('click', function() {
        customModelMain.classList.remove('model-open');
        window.setCookie("hide_popup", "yes", 180);
        const video1 = document.querySelector(".newsletter-popup .video-box video");
        if (!video1.paused) {
          video1.pause();
        }
      });
      actionsElement.appendChild(button);
      clearInterval(checkHubspotForm);
    } 
  }, 100); 
  // popup open on button click
  if(document.querySelectorAll(".newsletter-container").length > 0){
    var clickHere = document.querySelector(".newsletter-button");
    var closeButton = document.querySelectorAll(".close-btn, .bg-overlay, .newsletter-form__button.close");
    var customModelMain = document.querySelector(".newsletter-container .main");
    
    clickHere.addEventListener('click', function() {
      customModelMain.classList.add('model-open');
    });
    
    for (var i = 0; i < closeButton.length; i++) {
      closeButton[i].addEventListener('click', function() {
        customModelMain.classList.remove('model-open');
        window.setCookie("hide_popup", "yes", 180);
        const video = document.querySelector(".newsletter-popup .video-box video");
        if (!video.paused) {
          video.pause();
        }
      });
    }
  }
  
  if(window.getCookie("hide_popup") != "yes"){
    if(document.querySelectorAll(".newsletter-button").length > 0){
      setTimeout(function(){
        document.querySelector(".newsletter-button").click();
      },5000);
    }
  }

  // Interactive page functionality.
  const clickableElements = document.querySelectorAll('.interactive-container .clickable-image-block');

  // Add a click event listener to each element
  clickableElements.forEach(element => {
    element.addEventListener('click', () => {
      const parentElement = element.parentElement;
      Array.from(parentElement.children).forEach(siblingElement => {
        siblingElement.classList.remove('image-visibility-low');
      });
  
      Array.from(parentElement.getElementsByClassName('image-div')).forEach(siblingElement => {
        if (siblingElement !== element) {
          siblingElement.classList.add('image-visibility-low');
        }
      });
  
      let blockId = element.getAttribute("data-common-id");
  
      // For Video
      document.querySelectorAll(".interactive-container .middle-box .video-box").forEach(el => {
        el.style.opacity = "0";
      });
      document.querySelector(`#video-${blockId}`).style.opacity = "1";
  
      // For Text
      const sectionTextElement = document.querySelector(`#text-block-${blockId}`);
      Array.from(sectionTextElement.parentNode.children).forEach(childElement => {
        childElement.style.display = "none";
      });
      sectionTextElement.parentNode.classList.add("open");
      sectionTextElement.style.display = "block";
  
      element.parentNode.querySelector(".close-button").classList.add("open");
    });
  });

  document.querySelectorAll(".close-button").forEach(elem => {
    elem.addEventListener("click", () => {
      const parentElement = elem.parentElement;
      
      // Remove 'image-visibility-low' class from all sibling elements
      Array.from(parentElement.children).forEach(siblingElement => {
        siblingElement.classList.remove('image-visibility-low');
      });
      
      // For Video
      document.querySelectorAll(".middle-box .video-box").forEach(el => {
        el.style.opacity = "0";
      });
  
      // For Text
      document.querySelectorAll(".interactive-container .text-div").forEach(textEle => {
        textEle.style.display = "none";
      });
  
      // For Image
      document.querySelectorAll(".interactive-container .image-div").forEach(imgEle => {
        imgEle.style.display = "block";
      });
  
      // Reset close buttons
      document.querySelectorAll(".close-button").forEach(closeEle => {
        closeEle.parentNode.classList.remove("open");
        closeEle.classList.remove("open");
        closeEle.style.display = "";
      });
    });
  });

  document.querySelectorAll(".interactive-container-mobile .interactive_accordion").forEach(el => {
    el.addEventListener("click", () => {
      const accordionContent = el.querySelector(".accordion_content");
      const isAccordionOpen = el.classList.contains("open");
      if (!isAccordionOpen) {
        // Open the clicked accordion
  
        // Close all accordions
        document.querySelectorAll(".interactive-container-mobile .interactive_accordion").forEach(ele => {
          ele.classList.remove("open");
          ele.querySelector(".accordion_content").style.height = "0px";
        });
        const accordionItem = el;
        accordionItem.classList.add('open');
        if (accordionItem.classList.contains('open')) {
          accordionContent.style.height = accordionContent.scrollHeight + 'px';
        }
        accordionContent.style.display = "";
        accordionContent.querySelector("video").play();
        
        // Close other accordions
        let sibling = el.parentNode.firstElementChild;
        while (sibling) {
          if (sibling !== el && sibling.classList.contains("interactive_accordion")) {
            sibling.classList.remove("open");
          }
          sibling = sibling.nextElementSibling;
        }
      } else {
        // Close the clicked accordion
        el.classList.remove("open");
        accordionContent.style.height = "0px";
      }
    });
  });

  // Custom announcement bar countdown timer -- start
  
  window.timeCounter = function(dateTimeCustom){
    // Set the countdown date (format: "mm/dd/yyyy hh:mm:ss")
    var countdownDate = new Date(dateTimeCustom).getTime();
    let finalDateString = "";
    var countdown = setInterval(function() {
      var now = new Date().getTime();
      var distance = countdownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + (24 * days));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      finalDateString = "";

      // finalDateString += (days == 0) ? "" : days + "d ";
      // finalDateString += (hours == 0) ? "" : hours + "h ";
      // finalDateString += (minutes == 0) ? "" : minutes + "m ";
      // finalDateString += (seconds == 0) ? "" : seconds + "s ";
      // document.getElementById("countdown").innerHTML = finalDateString;

      // document.getElementById("countdown").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      document.getElementById("countdown").innerHTML = hours + "h " + minutes + "m " + seconds + "s ";
      if (distance < 0) {
        clearInterval(countdown);
        // document.getElementById("countdown").innerHTML = "Countdown expired";

        document.querySelector(".announcement-bar-default").classList.remove("visually-hidden");
        document.querySelector(".after-submit-announcement-bar").classList.add("visually-hidden");
        document.querySelector(".announcement-bar").classList.remove("custom-bar");
        window.setCookie("DiscountCodeApplied","");
        window.setCookie("form_submitted","");
        window.checkandapplyDiscount();
      }
    }, 1000);
  }

  if(document.querySelector("#countdown") != null)
  window.timeCounter(document.querySelector("#countdown").dataset.customdate)
  
  // Custom announcement bar countdown timer -- End

  // smooth scroll
  var links = document.querySelectorAll('a1[href*="#"]');
  
  
  links.forEach(function(link) {
    if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0' && link.getAttribute('href') !== '#recover' ) {
      link.addEventListener('click', function(event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = document.querySelector(this.hash);
          target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
          if (target) {
            event.preventDefault();
            window.scrollTo({
              top: target.offsetTop - 50,
              behavior: 'smooth'
            });
            var targetElement = document.querySelector(target);
            targetElement.focus();
            if (targetElement.matches(':focus')) {
              return false;
            } else {
              targetElement.setAttribute('tabindex', '-1');
              targetElement.focus();
            }
          }
        }
      });
    }
  });

  /* Flip image for product -- start */
  if (document.querySelectorAll(".flip-box").length > 0) {
    const flipBox = document.querySelector(".flip-box");
    const flipBoxPTag = flipBox.querySelector("p");
    const frontPTag = flipBox.querySelector("p.front-text");
    const backPTag = flipBox.querySelector("p.back-text");
    const thumbnailButtons = document.querySelectorAll(".flip-image-visible .thumbnail-slider ul li button");
    const firstButton = thumbnailButtons[0];
    const secondButton = thumbnailButtons[1];
  
    flipBox.addEventListener("click", () => {    
      if (firstButton.getAttribute("aria-current")) {
        setTimeout(() => {
          secondButton.click();
          backPTag.classList.add("hide-content");
          frontPTag.classList.remove("hide-content");
        }, 1);
      } else {
        setTimeout(() => {
          firstButton.click();
          frontPTag.classList.add("hide-content");
          backPTag.classList.remove("hide-content");
        }, 1);
      }
    });
  }
  /* Flip image for product -- End */

  /* Set Session after  */
  if(document.querySelectorAll("#create_customer > button").length > 0){
    document.querySelector("#create_customer > button").addEventListener("click", function(e){
      e.preventDefault();
      console.log("Form Not Submitted");
      sessionStorage.setItem("firstTimeLogin", 'yes');
      setTimeout(function(){
        document.querySelector("#create_customer").submit();    
      },500);
    }, true);
  }

  window.openCloseModal = function() {
   /* Modal Open */
    setTimeout(function(){
      document.body.classList.add("overflow-hidden");
      document.getElementById("modal-container").classList.add('show-modal');
    },500);
    
    /* Modal Close */
    const closeBtn = document.querySelectorAll('.close-modal');
    function closeModal(){
      const modalContainer = document.getElementById('modal-container')
      modalContainer.classList.remove('show-modal');
      document.body.classList.remove("overflow-hidden");
      sessionStorage.removeItem("firstTimeLogin");
      sessionStorage.removeItem("redirect");
    }
    closeBtn.forEach(c => c.addEventListener('click', closeModal));
    document.querySelector("body").addEventListener("click", function(e){
    if(e.target.classList.contains("modal__container-popup")){
        closeModal();
      }
    }, true);
  }

  /* code to show/hide modal after login for first time -- Start */
  if (sessionStorage.getItem("firstTimeLogin") == "yes") {
    if(document.querySelectorAll("#modal-container").length > 0){
     window.openCloseModal();
    }
  }
  /* code to show/hide modal after login for first time -- End*/

  // if(document.querySelectorAll("#addProductToCart--practitionerspecial").length > 0){
  //   document.querySelector("#addProductToCart--practitionerspecial").addEventListener("click", function(){
  //     setTimeout(function(){
  //         document.querySelector("#ProductSubmitButton-").click();
  //       },100);
  //   }, true)
  // }


  if(window.location.href.includes("/pages/reseller-portal")){

  
    function calculateDiscountedValue(originalPrice, discountPercentage) {
      var discountAmount = (originalPrice * discountPercentage) / 100;
      var discountedPrice = originalPrice - discountAmount;
      return discountedPrice;
    }
    
    const originalPriceRsEl = document.querySelectorAll(".reseller-purchase-line .product__info-wrapper product-info .price__sale .price-item")[0];
    const wholeSalePriceRsEl = document.querySelectorAll(".reseller-purchase-line .product__info-wrapper product-info .price__sale .price-item")[1];
    const originalPriceRs = originalPriceRsEl.innerText.replace("$","").replace(",","");
    const wholeSalePriceRs = wholeSalePriceRsEl.innerText.replace("$","").replace(",","");


    // const originalPriceRsOtEl = document.querySelectorAll(".one-time-product .product__info-wrapper .price__container .price-item")[1];
    // const wholeSalePriceRsOtEl = document.querySelectorAll(".one-time-product .product__info-wrapper .price__container .price__sale .price-item")[1];
    // const originalPriceRsOt = originalPriceRsOtEl?.innerText.trim().replace("$","");
    // const wholeSalePriceRsOt = wholeSalePriceRsOtEl?.innerText.trim().replace("$","");

    
    
    let discountRc = "";
    
    window.priceRc = function(onload = false){

      
      if(window.isReseller == "Reseller"){
        discountRc = 40.035273368607;
      }
      else if(window.isReseller == "Legacy_Reseller"){
        discountRc = 50;
      }
      let qtyIpRs = document.querySelector(".reseller-purchase-line .product__info-wrapper product-info .quantity-button-box input").value;
      
      originalPriceRsEl.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(((qtyIpRs/12) * originalPriceRs))}`;
      if(onload){
        // (typeof originalPriceRsOtEl !== "undefined") ? originalPriceRsOtEl.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format((qtyIpRs * originalPriceRs))}` : "";
      }
      
      if(onload){
        // wholeSalePriceRsEl.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(calculateDiscountedValue(originalPriceRs * 12, discountRc).toFixed(0))}`;
        // (typeof originalPriceRsOtEl !== "undefined") ? wholeSalePriceRsOtEl.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(calculateDiscountedValue(originalPriceRs * 12, discountRc).toFixed(0))}` : "";
      }
      else{
        wholeSalePriceRsEl.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(calculateDiscountedValue(originalPriceRs * (qtyIpRs/12), discountRc).toFixed(0))}`;
        // (typeof originalPriceRsOtEl !== "undefined") ? wholeSalePriceRsElOt.innerText = `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(calculateDiscountedValue(originalPriceRs * qtyIpRs, discountRc).toFixed(0))}` : "";
      }
    }
    // window.priceRc(true);
  }
  

  
   // if(window.location.href.includes("/account/activate")){
    if(document.querySelectorAll(".activate_account-reseller").length > 0){
      console.log(document.querySelectorAll(".activate_account-reseller").length);
      document.querySelector(".activate_account-reseller").addEventListener("click", function(){
        sessionStorage.setItem("redirect", '/pages/my-account');
        console.log("session set");
      })
    }
    // sessionStorage.setItem("redirect", '/pages/my-account');
    // console.log("session set");
  // }
  // else{
  //   if (sessionStorage.getItem("redirect")) {
  //     var redirectUrl = sessionStorage.getItem("redirect");
  //     sessionStorage.removeItem("redirect");
  //     window.location.href = redirectUrl;
  //   }
  // }

  if(window.location.href.includes("/pages/reseller-portal") && sessionStorage.getItem("redirect")){
    if(document.querySelectorAll("#modal-container").length > 0){
      window.openCloseModal();
    }
  }

  if(document.querySelectorAll(".popup_modal-add-to-cart").length > 0){
    document.querySelector(".popup_modal-add-to-cart").addEventListener("click", function(e){
      e.preventDefault();    
      sessionStorage.removeItem("redirect");
      window.location.href = e.target.parentNode.href;
    }, true);
  }
  
})
    